import { FileViewCell, RawTextCell } from '@/components/Table/components/Cell'
import { FilterType } from '@/components/Table/components/Filter/TableFilter'
import { Flex } from '@chakra-ui/react'
import { createColumnHelper } from '@tanstack/react-table'
import React from 'react'
import { MdDeleteOutline, MdOutlineCheckCircle } from 'react-icons/md'

const getCostCenterTableColumns = ({
  handleActivateCostCenter,
  handleDeleteCostCenter,
  procurementUserOptions = [],
  teamAssistantUserOptions = [],
}) => {
  const columnHelper = createColumnHelper()

  return [
    columnHelper.display({
      id: 'action',
      enableHiding: false,
      enableColumnFilter: false,
      cell: ({ row: { original } }) => {
        return (
          <>
            {original?.status === 'active' && (
              <Flex _hover={{ cursor: 'pointer' }} color="gray.400" justifyContent={'center'} w="100%">
                <MdDeleteOutline
                  size={24}
                  onClick={(e) => {
                    e.stopPropagation()
                    handleDeleteCostCenter(original._id)
                  }}
                />
              </Flex>
            )}
            {original?.status === 'inactive' && (
              <Flex _hover={{ cursor: 'pointer' }} color="green.400" justifyContent={'center'} w="100%">
                <MdOutlineCheckCircle
                  size={24}
                  onClick={(e) => {
                    e.stopPropagation()
                    handleActivateCostCenter(original._id)
                  }}
                />
              </Flex>
            )}
          </>
        )
      },
    }),

    columnHelper.accessor('profitCenterCode', {
      cell: RawTextCell,
    }),
    columnHelper.accessor('code', {}),
    columnHelper.accessor('quotationCode', {
      cell: RawTextCell,
    }),
    columnHelper.accessor('name', {
      cell: RawTextCell,
    }),
    columnHelper.accessor('description', {
      cell: RawTextCell,
    }),
    columnHelper.accessor('workInstructionAllowed', {
      header: () => <span>Work Instruction Allowed</span>,
      cell: ({ row: { original } }) => (original?.workInstructionAllowed ? 'Yes' : 'No'),
      enableColumnFilter: false,
    }),
    columnHelper.accessor('type', {
      meta: {
        filterVariant: FilterType.SELECT,
        filterOptions: [
          {
            value: 'maintenance',
            label: 'Maintenance',
          },
          {
            value: 'project',
            label: 'Project',
          },
        ],
      },
    }),
    columnHelper.accessor('defaultProcurement', {
      meta: {
        filterVariant: FilterType.MULTI_SELECT,
        filterOptions: procurementUserOptions,
      },
    }),
    columnHelper.accessor('defaultTeamAssistant', {
      meta: {
        filterVariant: FilterType.MULTI_SELECT,
        filterOptions: teamAssistantUserOptions,
      },
    }),
    columnHelper.accessor('numberOfTechnicalApprover', {
      header: () => <span># of Technical Approver</span>,

      enableColumnFilter: false,
    }),
    columnHelper.accessor('numberOfCommercialApprover', {
      header: () => <span># of Commercial Approver</span>,

      enableColumnFilter: false,
    }),
    columnHelper.accessor('status', {
      meta: {
        filterVariant: FilterType.SELECT,
        filterOptions: [
          {
            value: 'active',
            label: 'Active',
          },
          {
            value: 'inactive',
            label: 'Inactive',
          },
        ],
      },
    }),
  ]
}

export default getCostCenterTableColumns
